export default "__VITE_ASSET__17109b19__"